// extracted by mini-css-extract-plugin
module.exports = {"steps":"HowItWorks_steps__ohf_K","step":"HowItWorks_step__h7Elq","step-rw":"HowItWorks_step-rw__EPdYw"};